import useResponsive from '../useResponsive';
const useBetweenMdXl = ()=>useResponsive('between', undefined, 'md', 'xl');
export default useBetweenMdXl;
